import React from "react";
import { Rocket } from "lucide-react";
import { useLang } from "@/i18n";

export default function RolloutBar({ stats, autoSync }) {
  const { t } = useLang();
  const total = stats.total || 0;
  const installed = (stats.online || 0) + (stats.offline || 0);
  const pct = total ? Math.round((installed / total) * 100) : 0;
  return (
    <div className="card-surface rounded-xl p-4 sm:p-5" data-testid="rollout-bar">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Rocket className="w-4 h-4 text-[#c00000]" />
          <span className="text-xs font-mono uppercase tracking-wider text-gray-600">{t("rollout_title")}</span>
        </div>
        <div className="flex items-center gap-3">
          {autoSync && (
            <span className="flex items-center gap-1.5 text-[10px] font-mono uppercase tracking-wider text-[#c00000]">
              <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 pulse-dot" /> {t("auto_sync_on")}
            </span>
          )}
          <span className="font-display text-lg font-bold text-gray-900" data-testid="rollout-count">
            {installed} <span className="text-gray-600 text-sm font-normal">{t("rollout_of")} {total}</span>
          </span>
        </div>
      </div>
      <div className="h-2.5 w-full rounded-full bg-gray-50 overflow-hidden">
        <div
          className="h-full rounded-full bg-gradient-to-r from-[#c00000] to-[#c00000] transition-all duration-700"
          style={{ width: `${pct}%` }}
        />
      </div>
      <div className="mt-1.5 text-xs text-gray-600">
        {pct}% · {installed} {t("rollout_installed")}
      </div>
    </div>
  );
}
